import { useState } from 'react';
import { useSnackbar } from 'notistack';

import { importNewProducts } from '../../../../../crud/offer.crud';
import { useFormatMessage } from '../../../../../hooks';
import { getResponseMessage } from '../../../../../utils/utils';

export function useImportNewProducts() {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingUpload, setLoading] = useState(false);
  const [successUpload, setSuccess] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const fm = useFormatMessage();

  const upload = async (data: { file: FormData }) => {
    setLoading(true);
    importNewProducts(data)
      .then(res => {
        if (res.data.data.errors && res.data.data.errors.length > 0) {
          setErrors(res.data.data.errors);
        } else {
          setErrors([]);
          setSuccess(true);
        }
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
        }, 200);
      });
  };

  return { upload, loadingUpload, successUpload, errors };
}
